import { createApi } from '@reduxjs/toolkit/query/react';
import { graphqlRequestBaseQuery } from './base-query';

export const api = createApi({
    reducerPath: 'adminBffSdk',
    baseQuery: graphqlRequestBaseQuery(),
    endpoints: () => ({}),
});
